import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ServiceAreaCityContent } from '@trashlab/sitesapp/src/organizations/redebins/template/components/service-areas/city/service-area-city-content';

const ServiceAreaCityPage = () => {
  const { city } = Route.useParams();
  return <ServiceAreaCityContent citySlug={city} />;
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service-areas/$city',
  component: ServiceAreaCityPage,
});
